import React from 'react';
import { offerRows } from '../data/content';
import { CtaButton } from './CtaButton';
export function Offer() {
  return <section id="offer" className="w-full bg-white px-5 py-20 sm:py-28" data-id="element-121" data-mp="17xuswfmwwmsb">
      <div className="mx-auto max-w-md" data-id="element-122" data-mp="1mo2182j7gpfa">
        <h2 className="text-center font-display text-[1.6rem] font-black leading-tight tracking-tight text-ink sm:text-[2.2rem]" data-id="element-123" data-mp="1mmqz075erpqa">
          <span aria-hidden="true" data-id="element-124" data-mp="tyv5tcf1sfy9">🏆 </span>Offerta Speciale di Lancio
        </h2>

        <div className="relative mt-10 rounded-3xl border-2 border-brand bg-white px-7 pb-8 pt-11 shadow-soft" data-id="element-125" data-mp="u0xunt4gs31e">
          <span className="absolute -top-3 left-1/2 -translate-x-1/2 rounded-full bg-brand px-4 py-1.5 text-[10px] font-extrabold uppercase tracking-[0.14em] text-white" data-id="element-126" data-mp="13x15dnddt9zy">
            SCIENZE PRONTA™ Pack
          </span>

          <dl data-id="element-127" data-mp="2fbofq5tz1egx">
            {offerRows.map(row => <div key={row.label} className="flex items-center justify-between gap-4 border-b border-ink/10 py-4 text-sm" data-id="element-128" data-mp="2feano6krxvzo">
                <dt className="text-ink/80" data-id="element-129" data-mp="pjfkqbzwipjp">{row.label}</dt>
                <dd className="font-bold text-brand" data-id="element-130" data-mp="uj1ycmjn67t1">{row.value}</dd>
              </div>)}
            <div className="flex items-center justify-between border-b border-ink/10 py-4 text-sm" data-id="element-131" data-mp="ziocqzb7hu3f">
              <dt className="font-bold uppercase tracking-wide text-ink" data-id="element-132" data-mp="13ki7ys2mu5w7">
                Valore Totale:
              </dt>
              <dd className="font-bold text-amber-600 line-through" data-id="element-133" data-mp="6usehq5znu4j">€225</dd>
            </div>
          </dl>

          <p className="mt-6 text-center text-[11px] font-extrabold uppercase tracking-[0.16em] text-brand" data-id="element-134" data-mp="btlwnvw809b1">
            Solo per oggi
          </p>
          <p className="flex items-center justify-center gap-2 border-b border-ink/10 pb-7 pt-2" data-id="element-135" data-mp="kl4ai05p2d0y">
            <span className="text-4xl leading-none" aria-hidden="true" data-id="element-136" data-mp="3k8lzsqx37x0z">
              🏆
            </span>
            <span className="font-display text-6xl font-black leading-none text-brand" data-id="element-137" data-mp="3o9z9jc3awkd6">
              €19
            </span>
          </p>

          <p className="mt-5 text-center text-[11px] font-medium leading-relaxed text-ink/60" data-id="element-138" data-mp="vefs3yxu3yzi">
            <span aria-hidden="true" data-id="element-139" data-mp="qfurvzil1fb2">💳 </span>Pagamento unico, accesso a vita.
            Nessun abbonamento.
          </p>

          <CtaButton className="mt-4 w-full" data-id="element-140" data-mp="154qvnkdlw65v" />

          <p className="mt-4 text-center text-[11px] font-medium text-ink/50" data-id="element-141" data-mp="105xkvzppet9e">
            Download Istantaneo · Pagamento Unico · Accesso a Vita · Garanzia di
            7 Giorni
          </p>
        </div>
      </div>
    </section>;
}